import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "footer__top" }
const _hoisted_4 = { class: "footer__brand" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "footer__cols" }
const _hoisted_7 = { class: "footer__col" }
const _hoisted_8 = { class: "footer__col" }
const _hoisted_9 = { class: "footer__col" }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "footer__bottom" }
const _hoisted_14 = {
  class: "footer__legal",
  "aria-label": "Legal"
}

import icon from "@/assets/allading-icon.png";
import { APP_STORE_URL, GOOGLE_PLAY_URL, SUPPORT_EMAIL } from "@/content/links";


export default /*@__PURE__*/_defineComponent({
  __name: 'SiteFooter',
  setup(__props) {

const year = new Date().getFullYear();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "footer__logo",
            "aria-label": "Allading home"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _unref(icon),
                alt: "",
                width: "32",
                height: "32"
              }, null, 8, _hoisted_5),
              _cache[0] || (_cache[0] = _createElementVNode("span", null, "Allading", -1))
            ]),
            _: 1
          }),
          _cache[1] || (_cache[1] = _createElementVNode("p", { class: "footer__tagline" }, " Chats, voice notes and calls. Choose secure chats for end-to-end encrypted messages. ", -1))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "footer__heading" }, "Product", -1)),
            _createVNode(_component_router_link, { to: { path: '/', hash: '#features' } }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("Features", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: { path: '/', hash: '#security' } }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("Security", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: { path: '/', hash: '#download' } }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("Download", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[11] || (_cache[11] = _createElementVNode("h2", { class: "footer__heading" }, "Legal", -1)),
            _createVNode(_component_router_link, { to: "/legal" }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode("Privacy & terms", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/privacy" }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode("Privacy Policy", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/terms" }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createTextVNode("User Agreement", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/cookies" }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createTextVNode("Cookies & website", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/delete-account" }, {
              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                _createTextVNode("Delete account", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[12] || (_cache[12] = _createElementVNode("h2", { class: "footer__heading" }, "Get the app", -1)),
            (_unref(APP_STORE_URL))
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: _unref(APP_STORE_URL),
                  target: "_blank",
                  rel: "noopener"
                }, "App Store", 8, _hoisted_10))
              : _createCommentVNode("", true),
            _createElementVNode("a", {
              href: _unref(GOOGLE_PLAY_URL),
              target: "_blank",
              rel: "noopener"
            }, "Google Play", 8, _hoisted_11),
            _createElementVNode("a", {
              href: `mailto:${_unref(SUPPORT_EMAIL)}`
            }, _toDisplayString(_unref(SUPPORT_EMAIL)), 9, _hoisted_12)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("p", null, "© " + _toDisplayString(_unref(year)) + " Allading. All rights reserved.", 1),
        _createElementVNode("nav", _hoisted_14, [
          _createVNode(_component_router_link, { to: "/privacy" }, {
            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
              _createTextVNode("Privacy Policy", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/terms" }, {
            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
              _createTextVNode("User Agreement", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})